import React from 'react';

import MuiRadio, { RadioProps as MuiRadioProps } from '@mui/material/Radio';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const Radio = withCoreProps<RadioProps>(
  ({ className, ...props }: React.PropsWithChildren<RadioProps>) => {
    const clsxClass = clsx(className);

    return <MuiRadio {...props} className={clsxClass} />;
  },
);

export interface RadioProps extends MuiRadioProps, CoreProps {}
